export enum WsStreamType {
  BOOK_DEPTH = 'BookDepth',
  MARKET_PRICE = 'MarketPrice',
  ORDER_FILL = 'OrderFill',
  ORDER_UPDATE = 'OrderUpdate',
  SUBACCOUNT_LIQUIDATION = 'SubaccountLiquidation',
  TOKEN_TRANSFER = 'TokenTransfer',
}

export const WsNamespace = {
  STREAM: '/v1/stream',
  EXECUTE: '/v1/execute',
} as const;

export const WsExecutes = {
  ORDER_DRY_RUN: 'order:dryRun',
} as const;

export const SOCKET_OPTIONS = {
  transports: ['websocket'],
  /**
   * For reconnection to work, the backend must be configured with connection state recovery.
   * Example backend configuration:
   * ```
   * connectionStateRecovery: {
   *   // The backup duration of the sessions and the packets
   *   maxDisconnectionDuration: 10 * 1000, // 10s
   *   // Whether to skip middlewares upon successful recovery
   *   skipMiddlewares: true,
   * },
   * ```
   * But even if this were to be configured, we have to handle disconnects longer than the `maxDisconnectionDuration` manually.
   */
  reconnection: false,

  timeout: 20000,
  autoConnect: false,
  forceNew: true,
};
